import {  Injectable,  Output,  EventEmitter,  Injector } from '@angular/core';
import { HttpClient, HttpHeaders,  HttpHandler, HttpXhrBackend } from '@angular/common/http';
import { BehaviorSubject, Observable, Observer, map } from 'rxjs';
import { UserAuthentication } from '../interfaces/user-authentication';

const httpOptions = {
  headers: new HttpHeaders({
    Authorization: 'my-auth-token'
  }),
  
  reportProgress: true, 
  responseType: 'json' as 'json'
};


@Injectable({ providedIn: 'root' })


export class HTTPServiceWorker {

  
  results:Object[];
  loading:Boolean;

  readonly event: Observable<Event>;
  httpEvent:Event;
  _observer: Observer<Event>;
  @Output('onSearch') onSearch = new EventEmitter();
  progress:BehaviorSubject<number> = new BehaviorSubject(0)
  user:UserAuthentication = null;

  instance;
  http:HttpClient = null;

  constructor() { 
  }

  static getInstance(){
    return this; // or return a reference to this class
  }

  createHeader(authentication){
    if ( authentication){
      this.user = authentication;
      if ( this.user){
        httpOptions.headers = httpOptions.headers.set('Authorization', this.user.token );
      }else{
          throw ("Não existe autenticação no servidor de aplicação.");
      }
    }
    
  }

  public post( body:any, service:String,  authentication:UserAuthentication, apiRoot:string){
    
    const injector = Injector.create({
      providers: [
          { provide: HttpClient, deps: [HttpHandler] },
          { provide: HttpHandler, useValue: new HttpXhrBackend({ build: () => new XMLHttpRequest }) },
      ],
    });
    
    this.http = injector.get(HttpClient)

    this.httpEvent = new Event("startPost");

    if ( this._observer != undefined){
      this._observer.next(this.httpEvent);    
    }
    
    this.createHeader(authentication);
    

    return this.http.post(apiRoot+service,body,httpOptions).pipe(map(res=>{
          this.httpEvent = new Event("stopPost");
          
          if ( this._observer != undefined){
            this._observer.next(this.httpEvent);    
          }
          return res;
        
    },error=>{
        this.handleError(error);
    }));
      
  }

  public  handleError(error, throwError:Boolean = true) {
    this.httpEvent = new Event("stopPost");
    this._observer.next(this.httpEvent);   
    if ( throwError ){
      throw error;
    }
    
  };
  
}
